import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAvatarUrl } from '../../hooks/useAvatarUrl';
import HrnbImage from '../controls/HrnbImage';
import '../../css/chats/PinnedMessageBanner.css';

/**
 * Баннер закреплённого сообщения — отображается под шапкой чата.
 *
 * @param {Object} message — закреплённое сообщение
 * @param {Function} onUnpin — callback для открепления
 * @param {Function} onScrollTo — callback для прокрутки к сообщению
 */
export default function PinnedMessageBanner({ message, onUnpin, onScrollTo }) {
    const navigate = useNavigate();

    // Хук должен быть до раннего возврата для соблюдения правил React
    const senderAvatarId = typeof message?.sender === 'object'
        ? (message?.sender?.avatar || message?.sender?.profile?.avatar)
        : null;
    const avatarUrl = useAvatarUrl(senderAvatarId);

    if (!message) return null;

    const senderName = message.sender?.displayName
        || message.senderDisplayName
        || message.sender?.name
        || 'Пользователь';

    const text = message.isDeleted
        ? '[Сообщение удалено]'
        : (message.content || message.text || '[Вложение]');

    const handleProfileClick = (e) => {
        e.stopPropagation();
        const profileId = message.senderId
            || (typeof message.sender === 'object' ? message.sender.id : null);
        if (profileId) navigate(`/profile/${profileId}`);
    };

    return (
        <div className="pinned-banner" onClick={onScrollTo}>
            <span className="pinned-banner__icon">📌</span>
            <HrnbImage
                src={avatarUrl || '/default-avatar.png'}
                alt={senderName}
                size={24}
                rounded={true}
                className="pinned-banner__avatar pinned-banner__avatar-link"
                onClick={handleProfileClick}
            />
            <div className="pinned-banner__content">
                <span
                    className="pinned-banner__sender pinned-banner__sender-link"
                    onClick={handleProfileClick}
                >
                    {senderName}
                </span>
                <span className="pinned-banner__text">{text}</span>
            </div>
            <button
                type="button"
                className="pinned-banner__unpin"
                onClick={(e) => {
                    e.stopPropagation();
                    onUnpin?.(message);
                }}
                title="Открепить"
            >
                ✕
            </button>
        </div>
    );
}
